import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Box, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Section, GradientButton, AnimatedBox } from '../../components/ui';

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.1); opacity: 0.5; }
`;

const CTAWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 4),
  borderRadius: '24px',
  background: theme.palette.accent.gradient,
  overflow: 'hidden',
  textAlign: 'center',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    right: '-20%',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.1)',
    animation: `${pulse} 4s ease-in-out infinite`,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-30%',
    left: '-10%',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.08)',
    animation: `${pulse} 4s ease-in-out infinite`,
    animationDelay: '2s',
  },

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(6, 3),
  },
}));

const CTAContent = styled(Box)({
  position: 'relative',
  zIndex: 1,
});

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <Section>
      <Container maxWidth="lg">
        <AnimatedBox animation="scaleIn" duration="0.8s">
          <CTAWrapper>
            <CTAContent>
              <Typography
                variant="h2"
                sx={{
                  color: '#FFFFFF',
                  fontWeight: 700,
                  mb: 2,
                  maxWidth: '700px',
                  mx: 'auto',
                }}
              >
                {t('cta.ready.title')}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontSize: '1.125rem',
                  mb: 4,
                  maxWidth: '600px',
                  mx: 'auto',
                }}
              >
                {t('cta.ready.subtitle')}
              </Typography>

              <GradientButton
                component={Link}
                to="/contact"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  background: '#FFFFFF',
                  color: 'primary.main',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.9)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                {t('cta.ready.button')}
              </GradientButton>
            </CTAContent>
          </CTAWrapper>
        </AnimatedBox>
      </Container>
    </Section>
  );
}
